import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import AvatarFunc from '../components/AvatarFunc';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

function haQuanto(d) {
  if (!d) return 'nunca acessou';
  const dias = Math.floor((Date.now() - new Date(d).getTime()) / 86400000);
  if (dias <= 0) return 'hoje';
  if (dias === 1) return 'ontem';
  if (dias < 30) return `há ${dias} dias`;
  return new Date(d).toLocaleDateString('pt-BR');
}

export default function Equipe() {
  const { token } = useAuth();
  const [dados, setDados] = useState(null);
  const [filiais, setFiliais] = useState([]);
  const [filial, setFilial] = useState('');
  const [soPendentes, setSoPendentes] = useState(false);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    setCarregando(true);
    api.get('/equipe', { params: filial ? { filial } : {} })
      .then(({ data }) => { setDados(data); setFiliais(data.filiais || []); })
      .catch(() => setDados(null))
      .finally(() => setCarregando(false));
  }, [filial]);

  const nomeFilial = (cod) => filiais.find(x => x.codigo === String(cod))?.nome || `Filial ${cod}`;
  const lista = (dados?.equipe || []).filter(p => !soPendentes || p.pendente);
  const ehTotal = dados?.escopo === 'total';

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 900 }}>
        <h1 style={{ color: 'var(--verde)', fontWeight: 700, marginBottom: 4 }}>Minha Equipe</h1>
        <p style={{ color: 'var(--texto-suave)', marginTop: 0 }}>
          Acompanhe o andamento e as leituras dos seus liderados.
        </p>

        {dados && (
          <div className="equipe-resumo">
            <div className="equipe-stat"><span className="equipe-stat-num">{dados.resumo.total}</span> na equipe</div>
            <div className="equipe-stat equipe-stat--alerta"><span className="equipe-stat-num">{dados.resumo.com_pendencia}</span> com pendência</div>
            <div className="equipe-stat equipe-stat--ok"><span className="equipe-stat-num">{dados.resumo.total - dados.resumo.com_pendencia}</span> em dia</div>
          </div>
        )}

        <div className="acesso-filtros">
          {ehTotal && filiais.length > 0 && (
            <select className="doc-input" style={{ flex: 1, maxWidth: 220 }} value={filial} onChange={e => setFilial(e.target.value)}>
              <option value="">Todas as filiais</option>
              {filiais.map(x => <option key={x.codigo} value={x.codigo}>{x.nome}</option>)}
            </select>
          )}
          <label className="equipe-toggle">
            <input type="checkbox" checked={soPendentes} onChange={e => setSoPendentes(e.target.checked)} />
            Só quem tem pendência
          </label>
        </div>

        {carregando && <div>Carregando…</div>}
        {!carregando && (!dados || dados.equipe.length === 0) && (
          <div className="conteudo-card" style={{ textAlign: 'center', color: 'var(--texto-suave)', padding: '30px' }}>
            Você não tem liderados pra acompanhar por aqui.
          </div>
        )}

        <div className="equipe-lista">
          {lista.map(p => (
            <Link to={`/equipe/${p.id}`} className={`equipe-row equipe-row--link${p.pendente ? '' : ' equipe-row--ok'}`} key={p.id}>
              <div className="equipe-pessoa">
                <AvatarFunc id={p.id} nome={p.nome} temFoto={p.tem_foto} token={token} size={44} />
                <div className="equipe-pessoa-txt">
                  <div className="equipe-nome">{p.nome}</div>
                  <div className="equipe-sub">{p.cargo || 'sem cargo'} · {nomeFilial(p.filial)}</div>
                </div>
              </div>
              <div className="equipe-status">
                <div className="equipe-badges">
                  {p.trilhas_pendentes > 0 && (
                    <span className="equipe-badge equipe-badge--pend"><i className="bi bi-mortarboard"></i> {p.trilhas_pendentes} trilha{p.trilhas_pendentes > 1 ? 's' : ''}</span>
                  )}
                  {p.leituras_pendentes > 0 && (
                    <span className="equipe-badge equipe-badge--pend"><i className="bi bi-journal-text"></i> {p.leituras_pendentes} leitura{p.leituras_pendentes > 1 ? 's' : ''}</span>
                  )}
                  {!p.pendente && <span className="equipe-badge equipe-badge--ok"><i className="bi bi-check-circle-fill"></i> Em dia</span>}
                </div>
                <div className="equipe-acesso"><i className="bi bi-clock-history"></i> {haQuanto(p.ultimo_login)}</div>
              </div>
            </Link>
          ))}
        </div>
      </main>
    </>
  );
}
